import type React from 'react';
import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

const LazyDashboard = lazy(() => import('./Dashboard'));

const Dashboard = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => (
  <Suspense fallback={null}>
    <LazyDashboard {...props} />
  </Suspense>
);

export const dashboardRoute = {
  path: '/dashboard',
  element: <Dashboard />,
} as RouteObject;

export const dashboardFallbackRoute = {
  path: '/',
  element: <Dashboard />,
} as RouteObject;

export default Dashboard;
